<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Logs de Operações</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">                  
                    <div class="p-field p-col-12 p-md-2">
                        <label>Operação</label>
                        <Dropdown v-model="operacao" :options="operacoes" optionLabel="nome" optionValue="valor" placeholder="Selecione"/>                         
                    </div> 
                    <div class="p-field p-col-12 p-md-3">
                        <label>Usuário</label>
                        <Dropdown v-model="nomeLogin" :options="usuarios" optionLabel="nome" optionValue="nomeLogin" placeholder="Selecione"/>                         
                    </div> 
                    <div class="p-field p-col-12 p-md-2">
                        <label>Data início</label>
                        <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"/>
                    </div>  
                    <div class="p-field p-col-12 p-md-2">
                        <label>Data final</label>
                        <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"/>
                    </div>  
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Buscar" icon="pi pi-search" @click="pesquisar"/>
                    </div>                        
                </div>
                <DataTable :value="logsOps" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="data" header="Data da operação" sortable>
                        <template #body="slotProps">
                            {{ formatarStringDataHora(slotProps.data.data) }}
                        </template>                        
                    </Column>
					<Column field="loginUsuario" header="Login do usuário" sortable></Column>
                    <Column field="nomeUsuario" header="Nome do usuário" sortable></Column>
					<Column field="acao" header="Operação" sortable></Column>
                    <Column field="descricao" header="Descrição" sortable></Column>	
				</DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import LogOperacaoService from '@/service/LogOperacaoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    logOperacaoService: null,
    data() {
        return {
            dataInicio: new Date(),
            dataFinal: new Date(),
            nomeLogin: '',
            usuarios: [],
            operacoes: [],
            operacao: '',
            logsOps: [],
            filtro: {},
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        pesquisar() {         
            let requisicao = {
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                nomeLogin: this.nomeLogin, 
                operacao: this.operacao,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.logOperacaoService.pesquisar(requisicao)
            .then(resp => {
                this.logsOps = resp.data;                
            })
            .catch(erro => {console.log(erro);exibirMensagem(this, erro)});
        },
        listarUsuarios() {
            this.logOperacaoService.listarUsuarios({...this.getDadosRequisicao()})
            .then(resp => {
                this.usuarios = [{nome:'Todos', nomeLogin: ''}, ...resp.data];
            })
            .catch(erro => {exibirMensagem(this, erro)}); 
        },
        carregarOperacoes() {
            this.operacoes.push({nome:'Todos', valor:''});
            this.operacoes.push({nome:'Cadastrar', valor:'Cadastrar'});
            this.operacoes.push({nome:'Editar', valor:'Editar'});
            this.operacoes.push({nome:'Excluir', valor:'Excluir'});
            this.operacoes.push({nome:'Relatório', valor:'Relatório'});
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
        formatarStringDataHora(data) {
            let dataHora = data.split(' ');
			let partes = dataHora[0].split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0] + ' ' + dataHora[1];
		},
    },
    created() {
        this.logOperacaoService = new LogOperacaoService();
    },
    mounted() {
        this.carregarOperacoes();
        this.listarUsuarios();
    }
}
</script>

<style>

</style>